import { Component, _decorator } from 'cc';
import Delay from '../../../../common/scripts/Toolkit/Utils/Delay';

const { ccclass, property } = _decorator;

@ccclass('LoadingMachineTransition')
export default class LoadingMachineTransition extends Component {
    @property
    private readonly minDisplayDuration: number = 1000;

    public display(): Promise<void> {
        this.node.active = true;
        return Delay.resolve(this.minDisplayDuration);
    }

    public hide() {
        this.node.active = false;
    }
}
